export default __webpack_public_path__ + "scripts/resource/f3b2b61cdccd3e749be88f223323d18b.svg";